export { default } from './Chip';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Chip/index.js
// module id = 320
// module chunks = 0